import { createFileRoute } from '@tanstack/react-router';
import { z } from '@customerio/hydra-validation';
import JoinRequestPage from '@/pages/join-request/index.page';

const joinRequestSearchSchema = z.object({
  /** One-shot join token minted by signup code verification. */
  token: z.string().optional().catch(undefined),
});

/**
 * Public (unauthenticated) "request to join your org" page. Reached from the
 * signup flow after email verification, when the verified email's domain
 * matches an already-registered account.
 */
export const Route = createFileRoute('/join-request')({
  validateSearch: joinRequestSearchSchema,
  component: JoinRequestRoute,
});

function JoinRequestRoute() {
  const { token } = Route.useSearch();
  return <JoinRequestPage token={token} />;
}
